import { render } from "./saleableproduct.vue?vue&type=template&id=60b2e25c"
import script from "./saleableproduct.vue?vue&type=script&lang=js"
export * from "./saleableproduct.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__